export default "__VITE_ASSET__BmuYpbE$__"